// extracted by mini-css-extract-plugin
module.exports = {"kalkulatorPage":"KalkulatorPage_kalkulatorPage__FNk_S"};